import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import styles from './DefaultLayout.module.css';
export function DefaultLayout(props) {
    return (_jsx("div", { className: styles.defaultLayout, "data-testid": 'default-layout', children: _jsx("main", { className: styles.defaultLayoutContent, "data-testid": 'default-layout-content', children: props.children }) }));
}
